import axios from "axios";

const baseURL = process.env.VUE_APP_API_OFINANS_URI;
const ApiOfinans = axios.create({
  baseURL: baseURL
});

ApiOfinans.interceptors.request.use(
  config => {
    const token = localStorage.getItem("ofinans_token");
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(...error)
);

ApiOfinans.interceptors.response.use(
  response => response,
  error => {
    if ([404, 405, 500].includes(error?.response?.status)) {
      let errorMessage =
        "An unexpected error occurred. Please try again later.";
      throw {
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response.data,
            message: errorMessage
          }
        }
      };
    }
    throw error;
  }
);
export default ApiOfinans;
